import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled'
import setMinHeightByScreen from '../../component/script/set_minheight_by_screen';
import SearchBar from '../../component/input/search_bar';
import RankCombatStat from '../../component/rank/rank_combat_stat';
import FooterCommon from '../../component/common/footer_common';
import ReactGA from 'react-ga4';
import { Link } from 'react-router-dom';

const HomeWrapper = styled.main`

    @keyframes moveLeft {
        from {
            left:-960px;
        }
        to {
            left: -1920px;
        }
    }
    @keyframes moveRight {
        from {
            left:-1920px;
        }
        to {
            left:-960px;
        }
    }
    padding: 50px 20px;
    box-sizing: border-box;
    > section {
        max-width: 728px;
        margin: 0 auto;
    }
    .section-game-list {
        text-align: center;
        ul {
            display: flex;
            justify-content: center;
            li {
                position: relative;
                width: 100%;
                margin-top: 25px;
                border-radius: 25px;
                overflow: hidden;
                box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75), 5px 5px 10px 0px rgba(0, 0, 0, 0.05);
                &:hover{
                    box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75) inset, 5px 5px 10px 0px rgba(0, 0, 0, 0.05) inset;
                }
                a {
                    display: block;
                    width: 100%;
                    text-align: center;
                    border-radius: 25px;
                    .background-image {
                        position: absolute;
                        top:192px;
                        z-index: 1;
                        div {
                            transform: rotate(15deg);
                            img {
                                position: relative;
                                width: 2880px;
                                opacity: 0.1;
                                z-index: 1;
                                animation: moveLeft 60s linear Infinite;
                            }
                        }
                    }
                    article {
                        max-width: 250px;
                        position: relative;
                        display: flex;
                        flex-flow: column;
                        align-items: center;
                        gap: 25px;
                        padding: 25px;
                        z-index: 10;
                        margin: 0 auto;
                        img {
                            display: block;
                            width: 100%;
                        }
                        .button-fake {
                            display: inline-flex;
                            justify-content: center;
                            padding: 14px 25px;
                            border-radius: 99999px;
                            font-weight: 700;
                            background-color: var(--color-gray-blue-100);
                            color: var(--color-blue-900);
                            box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75), 2px 2px 5px 0px rgba(0, 0, 0, 0.05);
                            &:hover{
                                box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.05) inset;
                            }
                        }
                    }
                }
            }
        }
    }
    .section-combat-stat {
        margin-top: 100px;
        width: 100%;
        > h2 {
            img {
                display: block;
                width: 100%;
                max-width: 480px;
                margin: 0 auto;
            }
        }
    }
`

const Home = ()=>{
    const HomeWrapperRef = useRef(null)

    useEffect(()=>{
        if(window.location.href === "https://frieza.gabia.io/" || window.location.href === "http://maple-frieza.com/") {
            window.location.href="https://maple-frieza.com/";
        }
        setMinHeightByScreen(HomeWrapperRef);
        ReactGA.set({
            eventCategory: "홈"
        });
        ReactGA.send("pageview");
    },[])

    return(
        <HomeWrapper ref={HomeWrapperRef}>
            <h1 className="hidden">
                메이플스토리 전투력 측정기 홈(index)
            </h1>
            <section className="section-game-list">
                <ul>
                    <li>
                        <Link to="/game/minesweeper">
                            <div className="background-image">
                                <div>
                                    <img src="/image/banner/minesweeper_banner.png" alt="" />
                                </div>
                            </div>
                            <article>
                                <img src="/image/logo/title_minesweeper.png" alt="거짓으로 뒤덮인 메이플월드를 너의 선택으로 구해줘!!" />
                                <p>선택의 순간에 처한 메이플월드.<br/>정말 이대로 괜찮을까요?</p>
                                <div className="button-fake">
                                    시작하기!
                                </div>
                            </article>

                        </Link>
                    </li>
                </ul>
            </section>
            <section className="section-combat-stat">
                <h2>
                    <img src="/image/logo/main_logo.svg" alt="메이플스토리 전투력 측정기" />
                </h2>
                <SearchBar/>
                <RankCombatStat/>
            </section>
            
            <FooterCommon/>
        </HomeWrapper>
    )
}

export default Home;